module.exports = __webpack_public_path__ + "static/media/double_arrow.088be6f7.svg";